import useToast from '@/common/store/alert/useToast.ts';
import Toast from '@/common/components/base/toast/Toast.tsx';

const ToastProvider = () => {
  const { type, closeAlert, show, description } = useToast((state) => state);
  return (
    <Toast
      closeAlert={closeAlert}
      show={show}
      type={type}
      description={description}
    />
  );
};
export default ToastProvider;
